import { Shield, Clock, Star, Banknote, Award, Users } from "lucide-react";

const BADGES = [
  { icon: Shield, text: "Fully Insured", sub: "Up to £50k" },
  { icon: Clock, text: "On-Time Guarantee", sub: "Or we discount" },
  { icon: Star, text: "500+ 5-Star Reviews", sub: "Google Verified" },
  { icon: Banknote, text: "No Hidden Fees", sub: "Price = Price" },
  { icon: Award, text: "12+ Years Experience", sub: "Est. 2014" },
  { icon: Users, text: "Our Own Crews", sub: "Not agency staff" },
];

export const TrustBar = () => (
  <section className="bg-[#0F172A] py-5 overflow-hidden" data-testid="trust-bar">
    <div className="container-max px-4 sm:px-6 lg:px-8">
      <div className="flex gap-8 md:gap-0 md:grid md:grid-cols-6 overflow-x-auto md:overflow-visible scrollbar-hide">
        {BADGES.map((badge) => (
          <div key={badge.text} className="flex items-center gap-3 flex-shrink-0 md:flex-shrink md:justify-center">
            <div className="w-10 h-10 bg-white/10 flex items-center justify-center flex-shrink-0">
              <badge.icon className="w-5 h-5 text-[#FF5A1F]" />
            </div>
            <div className="min-w-0">
              <div className="text-white font-semibold text-sm leading-tight whitespace-nowrap">{badge.text}</div>
              <div className="text-white/50 text-xs whitespace-nowrap">{badge.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
